import React from 'react'
import LoaderSpinner from '../views/Widgets/LoaderSpinner'
import { Redirect } from 'react-router-dom'

export default (loader, collection) =>
  class AsyncComponent extends React.Component {
    constructor(props) {
      super(props)

      this.Component = null
      this.state = { Component: AsyncComponent.Component }
    }

    componentWillMount() {
      if (!this.state.Component) {
        loader()
          .then(Component => {
            AsyncComponent.Component = Component

            this.setState({ Component })
          })
          .catch(() => {
            this.setState({ Component: () => <Redirect to="/login" /> })
          })
      }
    }

    render() {
      if (this.state.Component) {
        return <this.state.Component {...this.props} {...collection} />
      }

      // return <LoaderSpinner />
      return null
    }
  }



// WEBPACK FOOTER //
// ./src/HOCs/asyncComponent.js